// export const environment = {
//   production: false,
//   baseUrl: "https://api.saatsheni.com",
//   baseApiUrl: "https://api.saatsheni.com/api/v1/admin",
//   clientUrl: "",
// };

export const environment = {
  production: false,
  baseUrl: "http://127.0.0.1:8000",
  baseApiUrl: "http://127.0.0.1:8000/api/v1/admin",
  clientUrl: "http://localhost:4200",
};
